import { useEffect, useState } from 'react';
import { Route, Routes, useParams } from 'react-router';

import { Content, Header, Spinner } from '../../common/components';
import routes from '../../common/constants/routes';
import { useAppSelector, useAppThunkDispatch, useDocumentTitle } from '../../common/hooks';
import { t } from '../../common/i18n';
import { getPoll, selectPoll } from '../../common/store/pollSlice';
import { selectSecurity } from '../../common/store/securitySlice';

// import { TabInfo } from './TabInfo';
import { TabDetail } from './TabDetail';

export const PollDetail: React.FC = () => {
  useDocumentTitle(t('Poll.title'));

  const { pollId = null } = useParams();
  const dispatch = useAppThunkDispatch();
  const poll = useAppSelector(selectPoll);
  const hasMoreBuildings = (useAppSelector(selectSecurity).buildings?.length ?? 0) > 1;
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isLoadFailed, setIsLoadFailed] = useState<boolean>(false);

  useEffect(() => {
    if (pollId === null) return;
    dispatch(getPoll(pollId))
      .unwrap()
      .then(() => setIsLoading(false))
      .catch(() => {
        // 404 = hlasování neexistuje nebo patří jinému domu (starý odkaz z e-mailu bez ?building=)
        setIsLoadFailed(true);
        setIsLoading(false);
      });
  }, [pollId, dispatch]);

  if (isLoading) return <Spinner size="large" position="overlay" />;

  if (isLoadFailed) {
    return (
      <>
        <Header title={t('Poll.title')} customBacklink={routes.poll} />
        <Content
          isEmpty={true}
          isEmptyText={t(hasMoreBuildings ? 'NotFound.textMoreBuildings' : 'NotFound.text', 'Poll.Detail')}
        />
      </>
    );
  }

  return (
    <>
      <Header
        title={poll.name || ''}
        customBacklink={`${routes.poll}`}
        tabs={[
          { label: 'Hlasování', to: '' },
          /* { label: 'Popis hlasování a přílohy', to: 'info' }, */
        ]}
      />

      <div className="Content">
        <Routes>
          <Route index element={<TabDetail />} />
          {/* <Route path="info" element={<TabInfo />} /> */}
        </Routes>
      </div>
    </>
  );
};

export default PollDetail;
